import qsa from "1dr-utils/helpers/elsForEach";
import { default as continueCheckout } from "@/js/parts/checkout/continueCheckout";
import { default as updateQuantities } from "@/js/parts/checkout/updateQuantities";
import { default as addToCart } from "@/js/parts/checkout/addToCart";
import { default as squarePayment } from "@/js/parts/checkout/square-payment";
import { default as loadOnSubmit } from "@/js/parts/checkout/loadOnSubmit";
import { default as farmcamp } from "@/js/parts/checkout/farmcamp";
import { default as selectLineItem } from "@/js/parts/checkout/selectLineItem";
import { default as toggleLineItem } from "@/js/parts/checkout/toggleLineItem";
import { default as guestEmails } from "@/js/parts/checkout/guest-emails";

let APP = window.APP || {};

const init = {
  continueCheckout,
  updateQuantities,
  addToCart,
  squarePayment,
  loadOnSubmit,
  farmcamp,
  selectLineItem,
  toggleLineItem,
  guestEmails,
};

APP.polyfillsReady.ready(function () {
  init.farmcamp();

  // Allow cached forms to scrape the token
  qsa("[data-csrf-required]", (form) => {
    form.addEventListener("submit", (e) => {
      e.preventDefault();

      var i = document.createElement("input");

      i.setAttribute("name", APP.config.csrfName);
      i.setAttribute("type", "hidden");
      i.setAttribute("value", APP.config.csrfValue);

      form.appendChild(i);

      form.submit();
    });
  });

  qsa(".SelectGroup", (group) => {
    group.dataset.total = 0;

    var validate = function (g) {
      g.dataset.total = 0;
      var selects = g.querySelectorAll("select");
      qsa(selects, (select) => {
        if (select.value) {
          ++g.dataset.total;
        }
      });
      if (g.dataset.total > 1) {
        qsa(selects, (select) => {
          if (!select.value) {
            select.disabled = true;
          }
        });
      } else {
        qsa(selects, (select) => {
          select.disabled = false;
        });
      }
    };

    qsa(group.querySelectorAll("[data-select-lineitem]"), (el) => {
      init.selectLineItem(el, group, validate);
    });

    var selects = group.querySelectorAll('select[name="camperSessions[]"]');
    qsa(selects, (select) => {
      select.addEventListener("change", () => {
        validate(group);
      });
    });
  });

  qsa("[data-toggle-lineitem]", (el) => {
    var callback = false;

    // Refresh the sessions booked if this was a toggling of sessions booked.
    init.toggleLineItem(el, callback);
  });

  const handleContinue = function (json, Form, readyFunction) {
    // move them forwards...
    var redirect = json.redirect;
    if (!redirect) {
      // If not, just redirect to the same page:
      redirect = window.location.href;
    }
    window.location = redirect;
    return;
  };

  // "Continue" refers generally to the button that goes to the next
  // step of the checkout. It will deal with its own _front end_ errors
  // on posting, by refreshing the page, but doesn't really
  // deal with json.error yet.
  init.continueCheckout("checkout-form", handleContinue);

  // These forms do not ajax, but let's keep behaviour
  // consistent and make them look like they're loading,
  // and disabled them, before a full page refresh:
  init.loadOnSubmit("coupon-form");

  init.loadOnSubmit("manual-payment");

  // for all our add to cart buttons, unlike quantities,
  // this is for adding something that was not there,
  // which will deal with the situation when it
  // _wasn't_ added, but craft didn't tell us, by doing
  // a lineitems-in-cart check.
  // (used for adding CSA to cart)
  qsa("[data-addtocart-form]", (form) => {
    init.addToCart(form);
  });

  // for all our lineitem updates, listen for QTY changes
  // and ajax the change.
  // (used for updating addons to the cart, on dining page)
  qsa("[data-lineitem-form]", function (form) {
    init.updateQuantities(form);
  });

  // Init square payment, it will do its own
  // check for whether there is a payment form
  init.squarePayment();

  init.guestEmails();
});
